import { Box, Typography, Chip } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';

interface PIPRecord {
  id?: string;
  caseNumber?: string;
  department?: string;
  openedDate?: string;
  targetDate?: string;
  reviewDate?: string;
  status?: string;
  outcome?: string;
  [key: string]: unknown;
}

interface EmployeePIPsProps {
  records: PIPRecord[];
}

export const EmployeePIPs = ({ records }: EmployeePIPsProps) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <TrendingUp color="primary" />
      <Typography variant="subtitle1" fontWeight={700}>Performance Reviews (PIPs)</Typography>
      <Chip label={`${records.length} records`} size="small" sx={{ ml: 1 }} />
    </Box>
    {records.length > 0 ? (
      <Box component="table" sx={{ width: '100%' }}>
        <Box component="thead">
          <Box component="tr">
            <Box component="td">PIP #</Box>
            <Box component="td">Department</Box>
            <Box component="td">Opened</Box>
            <Box component="td">Target Date</Box>
            <Box component="td">Review Date</Box>
            <Box component="td">Status</Box>
            <Box component="td">Outcome</Box>
          </Box>
        </Box>
        <Box component="tbody">
          {records.map(p => (
            <Box component="tr" key={p.id}>
              <Box component="td"><Chip label={p.caseNumber} size="small" /></Box>
              <Box component="td">{p.department}</Box>
              <Box component="td">{p.openedDate}</Box>
              <Box component="td">{p.targetDate}</Box>
              <Box component="td">{p.reviewDate}</Box>
              <Box component="td"><Chip label={p.status} size="small" color={p.status === 'Active' ? 'info' : p.status === 'Completed' ? 'success' : 'error'} /></Box>
              <Box component="td">{p.outcome || '—'}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    ) : (
      <Typography variant="body2" color="text.secondary">No PIPs found</Typography>
    )}
  </Box>
);
